import React from 'react';
import { Redirect } from 'react-router-dom';
import SetResponseCode from './SetResponseCode';

export default function RedirectWithCode({ code, ...rest }) {
  return (
    <>
      <SetResponseCode code={code} />
      <Redirect {...rest} />
    </>
  );
}
